module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0050.png.9605b5e0.jpg";